import React from 'react';
import { Link } from 'react-router-dom';
import { compliance } from '../config/compliance';

/**
 * 登录页与法律文档页共用的备案 / 协议入口。
 */
export default function LegalFooter({ compact = false }) {
  return (
    <div
      style={{
        marginTop: compact ? 20 : 0,
        paddingTop: compact ? 16 : 0,
        borderTop: compact ? '1px solid #e5e7eb' : 'none',
        textAlign: 'center',
        fontSize: 13,
        color: '#6b7280',
        lineHeight: 1.8,
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '8px 16px' }}>
        <Link to="/privacy">隐私政策</Link>
        <Link to="/agreement">用户协议</Link>
        <Link to="/about">关于我们</Link>
      </div>
      <div style={{ marginTop: 8 }}>
        <a href={compliance.icpQueryUrl} target="_blank" rel="noopener noreferrer">
          {compliance.icpFilingNumber}
        </a>
        <span style={{ margin: '0 6px' }}>·</span>
        <span>{compliance.companyName}</span>
      </div>
    </div>
  );
}
